export const TableFilterOperator = Object.freeze({
    AFTER: "after",
    BEFORE: "before",
    CONTAINS: "contains",
    CODE_VALUE_EQUALS: "codeValueEquals",
});
